module.exports = ".box-widget {\n  background-color: white;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.07);\n  border-bottom: 1px solid #dedede; }\n"